import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { addNewItem as onAddNewItem } from "store/products/actions"
import { getAllTaxes as onGetAllTaxes } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AddNewTax = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    gst: null,
    sgst: null,
    igst: null,
    cgst: null,
    invalidSum : null
  })
  const [gst, setGst] = useState(0)
  const [sgst, setSgst] = useState(0)
  const [cgst, setCgst] = useState(0)
  const [igst, setIgst] = useState(0)
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inpcode-gst').focus();
      document.getElementById('inpcode-gst').select();
    }, 250);
    
    if(props.enteredText != ''){
      setGst(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      setGst(props.detailsForEdit.gst)
      setSgst(props.detailsForEdit.sgst)
      setCgst(props.detailsForEdit.cgst)
      setIgst(props.detailsForEdit.igst)
    }
  }, [props.detailsForEdit])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (isNumber(value)) {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    
    if(isNumber(gst)){
      modifiedV["gst"] = true
    }
    else{
      modifiedV["gst"] = false
      formValid = false
    }

    if(isNumber(sgst)){
      modifiedV["sgst"] = true
    }
    else{
      modifiedV["sgst"] = false
      formValid = false
    }

    if(isNumber(cgst)){
      modifiedV["cgst"] = true
    }
    else{
      modifiedV["cgst"] = false
      formValid = false
    }

    if(isNumber(igst)){
      modifiedV["igst"] = true
    }
    else{
      modifiedV["igst"] = false
      formValid = false
    }

    if(formValid && (Number(gst) !== (Number(sgst)+Number(cgst)+Number(igst)))){
      modifiedV["invalidSum"] = false
      formValid = false
    }
    else{
      modifiedV["invalidSum"] = true
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    
    const formValid = validateForm()

    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'gst': gst,
        'sgst' : sgst,
        'igst' : igst,
        'cgst' : cgst,
      }, 'Tax')

      setShowLoading(false)
      if(response.status == 'success'){
        dispatch(onGetAllTaxes(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'gst': gst,
          'sgst' : sgst,
          'cgst' : cgst,
          'igst' : igst
        }, 'Tax')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllTaxes(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpcode-gst">
                              GST (%)
                            </Label>
                            <Input
                              type="text"
                              value={gst}
                              className="form-control"
                              id="inpcode-gst"
                              maxLength="5"
                              onChange={event => {
                                onChangeValidation("gst", event.target.value.trim())
                                if (isNumber(event.target.value)) {
                                  setGst(event.target.value)
                                }
                              }}
                              invalid={
                                validation["gst"] !== true &&
                                validation["gst"] !== null
                              }
                            />
                            {(validation["gst"] === false) &&
                              <div className="custom-error">
                                Please enter a valid GST (Only numbers)
                              </div>
                            }
                            {(validation["invalidSum"] === false) &&
                              <div className="custom-error">
                                Total GST is not matching with the sum of SGST, CGST & IGST 
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpcode-sgst">
                              SGST (%)
                            </Label>
                            <Input
                              type="text"
                              value={sgst}
                              className="form-control"
                              id="inpcode-sgst"
                              maxLength="5"
                              onChange={event => {
                                onChangeValidation("sgst", event.target.value.trim())
                                if (isNumber(event.target.value)) {
                                  setSgst(event.target.value)
                                }
                              }}
                              invalid={
                                validation["sgst"] !== true &&
                                validation["sgst"] !== null
                              }
                            />
                            {(validation["sgst"] === false) &&
                              <div className="custom-error">
                                Please enter a valid SGST (Only numbers)
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpcode-cgst">
                              CGST (%)
                            </Label>
                            <Input
                              type="text"
                              value={cgst}
                              className="form-control"
                              id="inpcode-cgst"
                              maxLength="5"
                              onChange={event => {
                                onChangeValidation("cgst", event.target.value.trim())
                                if (isNumber(event.target.value)) {
                                  setCgst(event.target.value)
                                }
                              }}
                              invalid={
                                validation["cgst"] !== true &&
                                validation["cgst"] !== null
                              }
                            />
                            {(validation["cgst"] === false) &&
                              <div className="custom-error">
                                Please enter a valid CGST (Only numbers)
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpcode-igst">
                              IGST (%)
                            </Label>
                            <Input
                              type="text"
                              value={igst}
                              className="form-control"
                              id="inpcode-igst"
                              maxLength="5"
                              onChange={event => {
                                onChangeValidation("igst", event.target.value.trim())
                                if (isNumber(event.target.value)) {
                                  setIgst(event.target.value)
                                }
                              }}
                              invalid={
                                validation["igst"] !== true &&
                                validation["igst"] !== null
                              }
                            />
                            {(validation["igst"] === false) &&
                              <div className="custom-error">
                                Please enter a valid IGST (Only numbers)
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                SAVE
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewTax.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewTax
